const Play = () => {
  return (
    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.7852 9.44781L0.916415 18.6096L0.916415 0.285991L16.7852 9.44781Z" fill="#171C60" />
    </svg>
  );
};

export default Play;
